/* eslint-disable webflow/module-top-level-imports */
import {type ExpressionF} from '@packages/systems/wfdl/GenericExpression/GenericExpressionTypes';
import {
  annotate as _annotate,
  stripAnn as _stripAnn,
  getAnn as _getAnn,
  updateAnn as _updateAnn,
  updateVal,
} from '@packages/utilities/annotated';
import {_stripAll} from '@packages/systems/wfdl/annotated-expression/AnnotatedExpressions';
import type {
  ContextualExpression,
  ContextualExpressionAnnotation,
} from './ContextualExpressionAST';

export const annotate = _annotate<
  ContextualExpressionAnnotation,
  ExpressionF<ContextualExpression>
>;
export const stripAnn = _stripAnn<
  ContextualExpressionAnnotation,
  ExpressionF<ContextualExpression>
>;
export const stripAll = _stripAll<ContextualExpressionAnnotation>;
export const getAnn = _getAnn<
  ContextualExpressionAnnotation,
  ExpressionF<ContextualExpression>
>;
export const updateAnn = (
  f: (a: ContextualExpressionAnnotation) => ContextualExpressionAnnotation,
  expr: ContextualExpression
) =>
  _updateAnn<
    ContextualExpressionAnnotation,
    ContextualExpressionAnnotation,
    ExpressionF<ContextualExpression>
  >(f)(expr);

export const updateExpr = updateVal<
  ContextualExpressionAnnotation,
  ExpressionF<ContextualExpression>,
  ExpressionF<ContextualExpression>
>;
